import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import ReactLoading from 'react-loading'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle, faFileInvoice, faTrash, faAngleLeft, faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Container,
  UncontrolledTooltip,
} from 'reactstrap'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { fetchInvoice, openDeleteInvoiceModal, editInvoice } from 'redux/actions/invoices'
import { loadSuppliers } from 'redux/actions/suppliers'
import InvoiceForm from 'components/Invoices/form'

class InvoiceDetail extends Component {

  state = {
    supplierId: null,
    totales: {
      amount: 0,
      iva: 0,
      subtotal: 0
    }
  }

  componentDidMount() {
    this.props.fetchInvoice(this.props.match.params.id)
    this.props.loadSuppliers()
  }

  render() {
    const { form, loading, openDeleteInvoiceModal, hasDependencies, suppliers, editInvoice, match } = this.props
    const id = `invoice_${form.id}`
    return (
      <Container className="pt-2 pt-md-5 pt-lg-6" fluid>
        <Row className="pb-3">
          <Col>
            <Button
              tag={Link}
              color="primary"
              to="/admin/invoices"
              size="sm"
              className="mt-2"
            >
              <FontAwesomeIcon icon={faAngleLeft} className="mr-2" />
              Regresar a Lista
            </Button>
          </Col>
        </Row>
        <Row>
          <Col className="order-xl-1" xl="12">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="12">
                    <h3 className="mb-0">
                      <FontAwesomeIcon icon={faFileInvoice} className="mr-1" /> Detalle de la Factura<br />
                      {hasDependencies && (
                        <UncontrolledTooltip target={id}>
                          No se puede editar esta factura porque ya está pagada
                        </UncontrolledTooltip>
                      )}
                      {hasDependencies && (
                        <UncontrolledTooltip target={`delete${id}btn`}>
                          No se puede eliminar esta factura porque ya está pagada
                        </UncontrolledTooltip>
                      )}
                      <Button
                        tag={Link}
                        color="primary"
                        to={`/admin/invoices/${match.params.id}/edit`}
                        size="sm"
                        className="mt-2"
                      >
                        <FontAwesomeIcon icon={faPencilAlt} className="mr-2" />
                        Editar Factura
                        {hasDependencies && (
                          <FontAwesomeIcon
                            id={id}
                            icon={faInfoCircle}
                            className="ml-2"
                          />
                        )}
                      </Button>
                      <Button
                        color="warning"
                        disabled={hasDependencies}
                        onClick={() => openDeleteInvoiceModal(form)}
                        size="sm"
                        className="mt-2"
                      >
                        <FontAwesomeIcon icon={faTrash} className="mr-2" />
                        Borrar Factura
                        {hasDependencies && (
                          <FontAwesomeIcon
                            id={`delete${id}btn`}
                            icon={faInfoCircle}
                            className="ml-2"
                          />
                        )}
                      </Button>
                    </h3>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                {!loading && form.notes && (
                  <InvoiceForm
                    readOnly
                    onSubmit={data => editInvoice(form.id, data)}
                    supplier={form.supplier}
                    invoice={form.invoice}
                    suppliers={suppliers}
                    supplierId={form.supplier}
                    loading={loading}
                    form={form}
                    notes={form.notes}
                    totales={this.state.totales}
                  />
                )}
                {loading && (
                  <ReactLoading type="spinningBubbles" color="#000" height={30} width={30} className="mt-3" />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    )
  }
}

const mapStateToProps = props => {
  const { invoices: { form, loadingInvoice }, suppliers: { suppliers } } = props
  return {
    form,
    loading: loadingInvoice,
    hasDependencies: get(form, 'paid', true),
    suppliers
  }
}

const mapDispatchToProps = dispatch => ({
  fetchInvoice: id => dispatch(fetchInvoice(id)),
  openDeleteInvoiceModal: invoice => dispatch(openDeleteInvoiceModal({ invoice, source: 'detail' })),
  loadSuppliers: () => dispatch(loadSuppliers({perPage: 1000})),
  editInvoice: (id, values) => dispatch(editInvoice(id, values))
})

InvoiceDetail.propTypes = {
  form: PropTypes.shape({
    id: PropTypes.number,
    landInvoices: PropTypes.arrayOf(PropTypes.shape({
      invoice: PropTypes.number,
      land: PropTypes.number,
      category: PropTypes.number,
      amount: PropTypes.number,
    })),
    supplier: PropTypes.oneOfType([
      PropTypes.shape({
        id: PropTypes.number,
        alias: PropTypes.string,
      }),
      PropTypes.string,
      PropTypes.number
    ]),
    invoice: PropTypes.shape({
      id: PropTypes.number,
    }),
    fileUrl: PropTypes.string
  }),
  loading: PropTypes.bool,
  openDeleteInvoiceModal: PropTypes.func.isRequired,
  fetchInvoice: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
    }).isRequired
  }).isRequired,
  hasDependencies: PropTypes.bool.isRequired
}

InvoiceDetail.defaultProps = {
  loading: false,
  form: {
    address: '',
    name: '',
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceDetail)
